import { useGetCurrentUser } from "@/hooks/queries/useGetCurrentUser";
import { PRODUCT_ALLOWED_EMAILS } from "@/lib/constants";

export const useIsUserInAllowedList = (
  allowedEmails: string[] = PRODUCT_ALLOWED_EMAILS,
): boolean => {
  const currentUser = useGetCurrentUser();

  return allowedEmails.includes(currentUser?.email.toLowerCase() ?? "");
};
